<div class="page-wraper">

    <router-outlet></router-outlet>

    <app-footer1></app-footer1>

</div>